module.exports = __webpack_public_path__ + "img/hot.d47ac1bb.svg";